interface Plan {
  id: number;
  attributes: {
    CustomerTypeDisplay: {
      id: number;
      DisplayType: string[];
    };
  };
}

export const custTypeMapping: Record<string, string> = {
  'All': 'User Type 1 (Not Logged In)',
  'not-logged-in': 'User Type 1 (Not Logged In)',
  'not-binded': 'User Type 2 (Logged In but not Binded)',
  '001': 'User Type 3 (VIM - Logged In & Binded but Cannot Upgrade)',
  '005': 'User Type 4 (Combo / Pack - Logged In & Binded and can Upgrade)',
  '004': 'User Type 5 (Pack/PCD - Logged In & Binded and can Upgrade)',
  '003': 'User Type 6 (Starter Pack / Free Channels)',
  '002': 'User Type 7 (Lamma Island - Logged In & Binded but Cannot Upgrade)',
  '008': 'User Type 8 (Now OTT - Logged In & Binded)',
  'ott': 'User Type 8 (Now OTT - Logged In & Binded)',
};

export const filterCustomerTypeDisplay = (plans: Plan[]): Plan[] => {
  let custType = window.myAppStrapi && window.myAppStrapi.cust_type;
  console.log("custType", custType);

  const isValidPlan = (plan: Plan) => plan.attributes?.CustomerTypeDisplay?.DisplayType != null;
  const filteredPlans = plans.filter(isValidPlan);

  let displayType = custTypeMapping['All'];

  if(custType){
    displayType = custTypeMapping[custType];
  }
  
  return filteredPlans.filter(plan => plan.attributes.CustomerTypeDisplay.DisplayType.includes(displayType));
};